try {
    if (!window.riReplaceWithHyphen) {
        var hyphens_1 = window.navHyphens || {};
        window.riReplaceWithHyphen = function (text) {
            var replacement = hyphens_1[text];
            if (replacement) {
                return replacement;
            }
            return text;
        };
        var eNav = document.querySelector('.MarginalNavigation');
        if (eNav) {
            var eSpans = eNav.querySelectorAll('span');
            for (var i = 0, max = eSpans.length; i < max; i++) {
                var eSpan = eSpans[i];
                if (eSpan.innerText.toLowerCase() == eSpan.innerHTML.toLowerCase()) {
                    eSpan.innerHTML = window.riReplaceWithHyphen(eSpan.innerHTML);
                }
            }
        }
    }
}
catch (ex) {
    console.error && console.error('Hyphen-Replacement: ', ex);
}
